export default "__VITE_ASSET__DYrikAsH__"